import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [receiptsOnly, setReceiptsOnly] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setReceiptsOnly(r.data.receipts_only)).catch(() => setReceiptsOnly(false));
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await api.post("/auth/refresh");
        setUser((await api.get("/auth/me")).data);
      } catch {
        setUser(false);
      }
    });
    const onExpire = () => setUser(false);
    window.addEventListener("auth:expired", onExpire);
    return () => window.removeEventListener("auth:expired", onExpire);
  }, []);

  const login = async (email, password) => setUser((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => setUser((await api.post("/auth/register", body)).data);
  const resetPassword = async (token, password) => setUser((await api.post("/auth/reset-password", { token, password })).data);
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, login, register, logout, resetPassword, receiptsOnly: !!receiptsOnly, configReady: receiptsOnly !== null }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
